// Platform-wide constants. Versiyon ve tier isimleri FE/BE'de aynı kaynaktan.

export * from "./audit-actions.js";
export * from "./sectors.js";

export const APP_NAME = "Mahir AI" as const;
export const API_VERSION = "v1" as const;

// Dahili sistem rolleri — plan §2.1 + Finar rev. madde 12 (2026-10-30): `superadmin`
// (Sistem Yöneticisi) admin'in üstünde; admin yetkilerinin tamamı + `kpi.catalog.categories`.
// (Müşteri katılımcı rolü `musteri` de sistem rolüdür ama dahili kullanıcıya atanmaz.)
export const SYSTEM_ROLES = ["superadmin", "admin", "consultant", "writer"] as const;
export type SystemRole = (typeof SYSTEM_ROLES)[number];

/** Sistem Yöneticisi rolünün DB adı (`roles.name`, migration 0067). */
export const SUPERADMIN_ROLE_NAME = "superadmin" as const;

/** Rol adının ekranda gösterilecek hali — bilinmeyen/özel rol adı olduğu gibi döner. */
export const ROLE_DISPLAY_NAMES: Readonly<Record<string, string>> = {
  superadmin: "Sistem Yöneticisi",
};

export function roleDisplayName(name: string): string {
  return ROLE_DISPLAY_NAMES[name] ?? name;
}

// On soru tipi — plan §4.4 / §6.3 + M15 composite. Tip `schemas/questions.ts`'den gelir (Zod enum).
export const QUESTION_TYPES = [
  "text",
  "numeric",
  "single",
  "multi",
  "date",
  "file",
  "table",
  "percent",
  "repeater",
  "composite",
] as const;

// Numeric soru için standart birimler — plan §5.4 body.4.
// FE dropdown'ı bu listeden beslenir; "özel" seçilince fallback text input.
// Schema'da `unit: string?` olarak tutulur — seçilen preset ya da custom değer.
export const NUMERIC_UNITS = [
  "GJ",
  "MWh",
  "kWh",
  "kg",
  "ton",
  "m³",
  "m²",
  "L",
  "km",
  "saat",
  "%",
  "adet",
  "kişi",
] as const;
export type NumericUnit = (typeof NUMERIC_UNITS)[number];

// project_participants.status durum makinesi — Müşteri Katılımcı Rolü
// (plan: docs/superpowers/plans/2026-07-23-musteri-katilimci-rolu.md).
// invited → active → submitted → (danışman yeniden açar) active; revoked her
// durumdan erişimi keser.
export const PARTICIPANT_STATUSES = ["invited", "active", "submitted", "revoked"] as const;
export type ParticipantStatus = (typeof PARTICIPANT_STATUSES)[number];
